<template>
  <!-- 贸易结算水表(终端用户远传表) -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-select ref="select" v-model="query.type" @change="handleChange" style="width: 120px">
                <a-select-option :value="1">一级材料</a-select-option>
                <a-select-option :value="3">二级材料</a-select-option>
                <a-select-option :value="2">三级材料</a-select-option>
              </a-select>
              <!-- <a-button type="primary" style="margin-left: 8px" @click="queryList">查询</a-button> -->
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()">删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)">编辑</a>
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model
        class="log-form"
        :model="addOrUpdateFo"
        ref="addOrUpdateFo"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级材料">
          <a-tree-select
            :replace-fields="{ title: 'materialsName', key: 'id', value: 'id' }"
            :tree-data="menuTreeData"
            v-model="addOrUpdateFo.pid"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="请选择上级材料"
            tree-default-expand-all
            @change="changeTree"
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="材料名称"
          hasFeedback
          v-if="extra !== 7"
          prop="materialsName"
        >
          <a-input placeholder="材料名称" v-model="addOrUpdateFo.materialsName" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="单位"
          prop="materialsUnit"
          hasFeedback
          v-if="extra == 5"
        >
          <a-input placeholder="单位" v-model="addOrUpdateFo.materialsUnit" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="规格"
          prop="specificationName"
          hasFeedback
          v-if="extra == 5"
        >
          <a-input placeholder="规格" v-model="addOrUpdateFo.specificationName" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="材料编码"
          hasFeedback
          prop="materialsCode"
          v-if="extra !== 7"
        >
          <a-input placeholder="材料编码" :disabled="disabled" v-model="addOrUpdateFo.materialsCode" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixinViewModule from '@/mixin/commonModel'
import { PERMISSION_ENUM } from '@/core/permission/permission'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  {
    title: '材料编码',
    dataIndex: 'materialsCode',
  },
  {
    title: '材料名称',
    dataIndex: 'materialsName',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
]

export default {
  mixins: [mixinViewModule],
  components: {},
  name: 'TaskManagement',
  data() {
    return {
      currentId: '',
      queryUrl: '/pipe-network/water_materialss/page',
      deleteUrl: '/pipe-network/water_materialss/del/',
      addOrUpdateUrl: '/pipe-network/water_materialss',
      queryOneUrl: '/pipe-network/water_materialss/',
      query: {
        type: 1,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      extra: 0,
      mateCode: true,
      disabled: false,
      isSpecification: true,
      menuTreeData: [],
      addOrUpdateFo: {
        pid: '',
        materialsName: '',
        materialsUnit: '',
        specificationName: '',
        materialsCode: '',
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },
  computed: {
    rules() {
      return {
        materialsName: [{ required: true, message: '请输入材料名称', trigger: 'change' }],
        materialsUnit: [{ required: true, message: '请输入单位', trigger: 'change' }],
        specificationName: [{ required: true, message: '请输入规格', trigger: 'change' }],
        materialsCode: [{ required: this.mateCode, message: '请输入材料编码', trigger: 'change' }],
      }
    },
    currentUser() {
      return this.$store.getters.userInfo
    },
  },
  created() {
    this.getMenuTree()
  },
  methods: {
    moment,
    getMenuTree() {
      let params = {
        id: '',
        type: '1',
      }
      this.$http
        .get('/pipe-network/water_materialss', { params })
        .then((res) => {
          this.menuTreeData = res.data
        })
        .catch(() => {})
    },
    changeTree(value, label, extra) {
      this.extra = extra.triggerNode._props.pos.length
      if (this.extra == 5) {
        this.mateCode = false
      } else {
        this.mateCode = true
      }
    },
    addOrUpdateHandle(id) {
      if (id !== undefined) {
        this.disabled = true
      } else {
        this.disabled = false
      }
      this.isUpdate = false
      this.currentId = id
      // this.addOrUpdateFo.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.addOrUpdateFo = {
              pid: data.pid,
              materialsName: data.materialsName,
              materialsUnit: data.materialsUnit,
              specificationName: data.specificationName,
              materialsCode: data.materialsCode,
            }
          })
          .catch(() => {})
      }
    },
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      const params = {
        idList: this.selectedRows,
        isSpecification: this.isSpecification,
      }
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .post(_this.deleteUrl, { ...params })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.queryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    },
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {
          type: 1,
        }
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    handleOk(e) {
      this.$refs.addOrUpdateFo.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](
            this.addOrUpdateUrl,
            this.query.sysType
              ? { id: this.currentId, sysType: this.query.sysType, ...this.addOrUpdateFo }
              : { id: this.currentId, ...this.addOrUpdateFo }
          )
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.$refs.addOrUpdateFo.resetFields()
                this.extra = 0
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    handleCancel() {
      this.$refs.addOrUpdateFo.resetFields()
      this.extra = 0
      this.addOrUpdateVisible = false
    },
    handleChange(value) {
      if (value == 2) {
        this.isSpecification = false
      } else {
        this.isSpecification = true
      }
      if (value == 2) {
        this.columns.splice(3)
        this.columns.splice(
          3,
          {
            title: '',
            dataIndex: '',
          },
          {
            title: '上级材料',
            dataIndex: 'higherName',
          },
          {
            title: '规格',
            dataIndex: 'specificationName',
          },
          {
            title: '单位',
            dataIndex: 'materialsUnit',
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
          }
        )
        this.queryList()
      } else if (value == 3) {
        this.columns.splice(3)
        this.columns.splice(
          3,
          {
            title: '',
            dataIndex: '',
          },
          {
            title: '上级材料',
            dataIndex: 'higherName',
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
          }
        )
        this.queryList()
      } else {
        this.columns.splice(3)
        this.columns.splice(
          3,
          {
            title: '',
            dataIndex: '',
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
          }
        )
        this.queryList()
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
}
</style>
